import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchRequestParams } from '../../../../../interfaces/src/lib/types/index';
import { SearchResponse } from '@algolia/client-search';

const initialState: SearchRequestParams = {
  params: { distinct: 0, hitsPerPage: 8, filters: '', facets: '*' },
  excursionsData: null,
  itineraryData: null,
  itineraryDataButton: null,
  excursionsDataButton: null,
  itineraryMultifilterData: null,
  facetsData: null,
  cruiseData: null,
  cabinAndDatesData: null,
  loading: false,
  error: null,
  filters: '',
  hitsPerPage: 8,
  context: [],
};

export interface SearchState {
  params: {
    distinct: number;
    hitsPerPage: number;
    filters: string;
    facets: string;
  };
  excursionsData: SearchResponse;
  itineraryData: SearchResponse;
  itineraryDataButton: SearchResponse;
  excursionsDataButton: SearchResponse;
  facetsData: SearchResponse;
  itineraryMultifilterData: any;
  excursionsMultifilterData: any;
  cruiseData: SearchResponse;
  cabinAndDatesData: any;
  loading: boolean;
  error: string | null;
}

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    searchFacetsRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchFacetSuccess: (state, action) => {
      state.loading = false;
      state.facetsData = action.payload;
      state.error = null;
    },
    searchItineraryMultifilterRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchItineraryMultifilterSuccess: (state, action) => {
      state.loading = false;
      state.itineraryMultifilterData = action.payload;
      state.error = null;
    },
    searchItineraryButtonRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchItineraryButtonSuccess: (state, action) => {
      state.loading = false;
      state.itineraryDataButton = action.payload;
      state.error = null;
    },
    searchItineraryRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },

    searchItinerarySuccess: (state, action) => {
      state.loading = false;
      state.itineraryData = action.payload;
      state.error = null;
    },
    searchItineraryFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },

    searchExcursionsButtonRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchExcursionsButtonSuccess: (state, action) => {
      state.loading = false;
      state.excursionsDataButton = action.payload;
      state.error = null;
    },
    searchExcursionsRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchExcursionsSuccess: (state, action) => {
      state.loading = false;
      state.excursionsData = action.payload;
      state.error = null;
    },
    searchExcursionsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    searchCruiseRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchCruiseRequestAir: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchCruiseSuccess: (state, action) => {
      state.loading = false;
      state.cruiseData = action.payload;
      state.error = null;
    },
    searchCruiseSuccessAir: (state, action) => {
      state.loading = false;
      state.cruiseData = action.payload;
      state.error = null;
    },
    searchCruiseFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    searchCruiseFailureAir: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    searchCabinAndDatesRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchCabinAndDatesRequestAir: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchCabinAndDatesSuccess: (state, action) => {
      state.loading = false;
      state.cabinAndDatesData = action.payload;
      state.error = null;
    },
    searchCabinAndDatesSuccessAir: (state, action) => {
      state.loading = false;
      state.cabinAndDatesData = action.payload;
      state.error = null;
    },
    searchCabinAndDatesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    searchCabinAndDatesFailureAir: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    searchMultipleCabinAndDatesRequest: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchMultipleCabinAndDatesRequestAir: (state, action) => {
      state.params = action.payload;
      state.loading = true;
      state.error = null;
    },
    searchMultipleCabinAndDatesSuccess: (state, action) => {
      state.loading = false;
      state.cabinAndDatesData = action.payload;
      state.error = null;
    },
    searchMultipleCabinAndDatesFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    searchMultipleCabinAndDatesSuccessAir: (state, action) => {
      state.loading = false;
      state.cabinAndDatesData = action.payload;
      state.error = null;
    },
    searchMultipleCabinAndDatesFailureAir: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  searchFacetsRequest,
  searchFacetSuccess,
  searchItineraryMultifilterRequest,
  searchItineraryMultifilterSuccess,
  searchItineraryButtonRequest,
  searchItineraryButtonSuccess,
  searchItineraryRequest,
  searchItinerarySuccess,
  searchItineraryFailure,
  searchExcursionsRequest,
  searchExcursionsSuccess,
  searchExcursionsFailure,
  searchExcursionsButtonRequest,
  searchExcursionsButtonSuccess,
  searchCruiseRequest,
  searchCruiseRequestAir,
  searchCruiseSuccess,
  searchCruiseSuccessAir,
  searchCruiseFailure,
  searchCruiseFailureAir,
  searchCabinAndDatesRequest,
  searchCabinAndDatesRequestAir,
  searchCabinAndDatesSuccess,
  searchCabinAndDatesFailure,
  searchCabinAndDatesSuccessAir,
  searchCabinAndDatesFailureAir,
  searchMultipleCabinAndDatesRequest,
  searchMultipleCabinAndDatesRequestAir,
  searchMultipleCabinAndDatesSuccess,
  searchMultipleCabinAndDatesFailure,
  searchMultipleCabinAndDatesSuccessAir,
  searchMultipleCabinAndDatesFailureAir,
} = searchSlice.actions;
export default searchSlice.reducer;
